import { forwardRef, type Ref, type SVGProps } from "react";
const IconRedoOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 2a1 1 0 0 0-1 1v8.272l-6.64-6.636A9 9 0 1 0 6.632 17.364l12.343 12.343a1 1 0 0 0 1.426.012 1 1 0 0 0-.012-1.426L8.046 15.95a7 7 0 0 1 9.9-9.9L24.9 13H16a1 1 0 1 0 0 2h10.5a1.5 1.5 0 0 0 1.5-1.5V3a1 1 0 0 0-1-1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRedoOutlineSVG);
ForwardRef.displayName = "IconRedoOutline";
export { ForwardRef as IconRedoOutline };
